import React from "react";
import { connect } from "react-redux";
import { FormattedMessage, injectIntl } from "react-intl";
import {
  getE4madAuditDesk,
  getE4madAuditHome,
  getE4madInterventions,
  getE4madMaintenances,
  getE4madMercurials,
  getE4madPatients,
  getE4madPrescribers,
} from "../../../actions/stats/stats";

class StatsE4mad extends React.Component {
  render() {
    const links = [
      {
        fileName: "e4mad_prescripteurs_par_clients",
        onExport: this.props.onGetE4madPrescribers,
        formattedMessage: "Nb.Prescribers.By.Psdm",
      },
      {
        fileName: "e4mad_patients_par_clients",
        onExport: this.props.onGetE4madPatients,
        formattedMessage: "Nb.Patients.By.Psdm",
      },
      {
        fileName: "e4mad_mercuriales_par_clients",
        onExport: this.props.onGetE4madMercurials,
        formattedMessage: "Nb.Mercurials.By.Psdm",
      },
      {
        fileName: "e4mad_interventions_par_clients",
        onExport: this.props.onGetE4madInterventions,
        formattedMessage: "Nb.Interventions.By.Psdm",
      },
      {
        fileName: "e4mad_maintenances_par_clients",
        onExport: this.props.onGetE4madMaintenances,
        formattedMessage: "Nb.Maintenances.By.Psdm",
      },
      {
        fileName: "e4mad_audits_domicile_par_clients",
        onExport: this.props.onGetE4madAuditHome,
        formattedMessage: "Nb.Audit.Home.By.Psdm",
      },
      {
        fileName: "e4mad_audit_magasin_par_clients",
        onExport: this.props.onGetE4madAuditDesk,
        formattedMessage: "Nb.Audit.Desk.By.Psdm",
      },
    ];

    const linksNode = links.map((link, index) => {
      return (
        <li key={index}>
          <button
            className="btn btn-link"
            onClick={() =>
              this.props.openConfModal(link.fileName, (successCallback) =>
                link.onExport(successCallback),
              )
            }
          >
            <FormattedMessage id={link.formattedMessage} />
          </button>
        </li>
      );
    });

    return (
      <div>
        <ul style={{ listStyleType: "none" }}>{linksNode}</ul>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    //
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    onGetE4madPrescribers: (successCallback) =>
      dispatch(getE4madPrescribers(successCallback)),
    onGetE4madPatients: (successCallback) =>
      dispatch(getE4madPatients(successCallback)),
    onGetE4madMercurials: (successCallback) =>
      dispatch(getE4madMercurials(successCallback)),
    onGetE4madInterventions: (successCallback) =>
      dispatch(getE4madInterventions(successCallback)),
    onGetE4madMaintenances: (successCallback) =>
      dispatch(getE4madMaintenances(successCallback)),
    onGetE4madAuditHome: (successCallback) =>
      dispatch(getE4madAuditHome(successCallback)),
    onGetE4madAuditDesk: (successCallback) =>
      dispatch(getE4madAuditDesk(successCallback)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectIntl(StatsE4mad));
